import { CrudModes } from "@app/shared/components/abstracts/base-component";
import { AbstractAdapter } from "@app/shared/models/adapter.model";
import { Field } from "@app/shared/models/form-field.model";

export class ConfigIdParms {
  constructor(
    public id: string,
    public mode: CrudModes,
    public appId: string
  ) {}
}

export interface DocumentsPlusConfiguration {
  applicationId: string;
  uniqueId: Field;
  idFieldText: Field;
  indexFieldText: Field;
  isPositionToIndex: Field;
  descriptionToUse: Field;
  docTypeFirst: Field;
  descrAutoPopulate: Field;
  scanDefaultResolution: Field;
  scanDefaultColor: Field;
}

export interface DocumentsPlusConfigValues {
  applicationId: string;
  appConfiguration: DocumentsPlusApplicationConfig;
  scannerConfiguration: DocumentsPlusScannerConfig;
}

export interface DocumentsPlusApplicationConfig {
  idFieldText: string;
  indexFieldText: string;
  isPositionToIndex: boolean;
  descriptionToUse: string;
  docTypeFirst: boolean;
  descrAutoPopulate: boolean;
}

export interface DocumentsPlusScannerConfig {
  scanDefaultResolution: string;
  scanDefaultColor: string;
}

export interface DocumentsPlusConfigurationId {
  applicationId: string;
  applicationIdValuesList: DocumentsPlusConfigurationIdList[];
}

export interface DocumentsPlusConfigurationIdList {
  uniqueId: string;
  id: string;
  description: string;
  default: boolean;
  isSelected?: boolean;
  _default?: string;
}

export interface DocumentsPlusConfigurationIdMaintenance {
  uniqueId: string;
  applicationId: Field;
  id: Field;
  description: Field;
  default: Field;
}

export interface DocumentsPlusConfigurationListMaintenance {
  uniqueId: string;
  applicationId: Field;
  id: Field;
  description: Field;
}

export class DocumentsPlusConfigurationAdapter extends AbstractAdapter<DocumentsPlusConfiguration> {
  adapt(rawData: DocumentsPlusConfiguration) {
    return rawData;
  }
}
export class DocumentsPlusConfigurationByApplicationIdAdapter extends AbstractAdapter<DocumentsPlusConfigValues> {
  adapt(rawData: DocumentsPlusConfigValues) {
    return rawData;
  }
}

export class DocumentsPlusConfigurationListAdapter extends AbstractAdapter<DocumentsPlusConfigurationIdList[]> {
  adapt(rawData: DocumentsPlusConfigurationId) {
    (rawData.applicationIdValuesList as DocumentsPlusConfigurationIdList[]).map((e) => {
      e._default = e.default ? this.translate("APP.LBL_YES") : this.translate("APP.LBL_NO");
      e.isSelected = false;
      return e;
    });
    return rawData?.applicationIdValuesList ?? [];
  }
}
